import request from '@/utils/request'

export function groupByDuty(pv) {
  return request({
    url: '/robot/groupByDuty',
    method: 'post',
    data: { ...pv }
  })
}

export function positonInfo(pv) {
  return request({
    url: '/robot/positonInfo',
    method: 'post',
    data: { ...pv }
  })
}

export function controlCommand(pv) {
  return request({
    url: '/robot/controlCommand',
    method: 'post',
    data: { ...pv }
  })
}

export function initialize(pv) {
  return request({
    url: '/robot/initialize',
    method: 'post',
    data: { ...pv }
  })
}

// 巡检路线
export function robotRouteByRobotId(pv) {
  return request({
    url: '/robot/robotRouteByRobotId?robotId=' + pv.replaceAll("\"", ""),
    method: 'get'
  })
}

// 机器人避让
export function getMapAndRouteByNumber(pv) {
  return request({
    url: '/robot/getMapAndRouteByNumber',
    method: 'post',
    data: { ...pv }
  })
}



// WEBPACK FOOTER //
// ./src/api/user.js